import { useContext } from 'react';
import { ViewCalendarYearContext } from 'src/sections/view_periods/ViewCalendarYearContext';

const useViewCalendarYear = () => {
  const context = useContext(ViewCalendarYearContext);
  if (!context)
    throw new Error('View Checkbook context must be used inside ViewPeriodContextProvider');
  return context;
};

export default useViewCalendarYear;
